import styled from 'styled-components';

export const Green = styled.span`
  color: green;
`;

export const Red = styled.span`
  color: red;
`;
